export const emailValidate = email => {
  var regex = /^([_\.\-0-9a-zA-Z]+)@([_\.\-0-9a-zA-Z]+)\.([a-zA-Z]){2,20}$/;

  if (regex.test(email) && email !== '') {
    return true;
  } else {
    return false;
  }
}
